/**
 * Onak's Touch theme behaviours
 *
 * Designed by Pankaj Maurya
 * Property of designflowdigitals.com
 * © All rights reserved. Unauthorized copying or redistribution is prohibited.
 */
(function () {
  var cartRoot =
    (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function initReveal() {
    var els = document.querySelectorAll('.ot-rv:not(.in)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) {
        el.classList.add('in');
      });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('in');
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    els.forEach(function (el) {
      io.observe(el);
    });
  }

  function initAccordions() {
    document.querySelectorAll('.ot-fq, .ot-ac').forEach(function (el) {
      if (el.dataset.otBound) return;
      el.dataset.otBound = '1';
      el.addEventListener('click', function () {
        el.classList.toggle('open');
      });
    });
  }

  function initGallery() {
    document.querySelectorAll('[data-ot-gallery]').forEach(function (gal) {
      if (gal.dataset.otBound) return;
      gal.dataset.otBound = '1';
      var main = gal.querySelector('[data-ot-main-img]');
      gal.querySelectorAll('[data-ot-thumb]').forEach(function (th) {
        th.addEventListener('click', function () {
          gal.querySelectorAll('[data-ot-thumb]').forEach(function (x) {
            x.classList.remove('on');
          });
          th.classList.add('on');
          if (main && th.dataset.src) {
            main.src = th.dataset.src;
            if (th.dataset.srcset) main.srcset = th.dataset.srcset;
          }
        });
      });
    });
  }

  function initQty() {
    document.querySelectorAll('[data-ot-qty]').forEach(function (wrap) {
      if (wrap.dataset.otBound) return;
      wrap.dataset.otBound = '1';
      var input = wrap.querySelector('input[name="quantity"], .ot-qty-val');
      var buttons = wrap.querySelectorAll('button');
      if (!input || buttons.length < 2) return;
      buttons[0].addEventListener('click', function (e) {
        e.preventDefault();
        var v = Math.max(1, (parseInt(input.value || input.textContent, 10) || 1) - 1);
        if (input.tagName === 'INPUT') input.value = v;
        else input.textContent = v;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
      buttons[1].addEventListener('click', function (e) {
        e.preventDefault();
        var v = (parseInt(input.value || input.textContent, 10) || 1) + 1;
        if (input.tagName === 'INPUT') input.value = v;
        else input.textContent = v;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  function initStickyAtc() {
    var sticky = document.getElementById('ot-sticky');
    var trigger = document.querySelector('[data-ot-sticky-trigger]');
    if (!sticky || !trigger) return;
    function onScroll() {
      var rect = trigger.getBoundingClientRect();
      sticky.classList.toggle('show', rect.bottom < 0);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  function updateCartCount(count) {
    var el = document.getElementById('ot-cart-count');
    if (el == null) return;
    if (typeof count === 'number') {
      el.textContent = String(count);
      return;
    }
    fetch(cartRoot + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        el.textContent = String(cart.item_count || 0);
      })
      .catch(function () {});
  }

  function getCartSectionIds() {
    var ids = [];
    document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (el) {
      var id = el.getAttribute('data-section-id');
      if (id && ids.indexOf(id) === -1) ids.push(id);
    });
    if (ids.indexOf('cart-drawer-section') === -1) {
      ids.push('cart-drawer-section');
    }
    return ids;
  }

  function openCartDrawer() {
    var drawer = document.getElementById('cart-drawer');
    if (drawer && typeof drawer.open === 'function') {
      drawer.open();
      return true;
    }
    var comp = document.querySelector('cart-drawer-component');
    var parent = comp && comp.closest('theme-drawer');
    if (parent && typeof parent.open === 'function') {
      parent.open();
      return true;
    }
    return false;
  }

  /**
   * Replace a Shopify section in the DOM from Section Rendering API HTML.
   */
  function applySectionHtml(sectionId, html) {
    if (!html) return false;
    var existing = document.getElementById('shopify-section-' + sectionId);
    if (!existing) return false;

    var doc = new DOMParser().parseFromString(html, 'text/html');
    var next =
      doc.getElementById('shopify-section-' + sectionId) ||
      doc.querySelector('.shopify-section') ||
      doc.body.firstElementChild;

    if (!next) {
      // API sometimes returns section inner HTML only
      existing.innerHTML = html;
      return true;
    }

    // Preserve open state of theme-drawer when re-rendering
    var drawerBefore = document.getElementById('cart-drawer');
    var wasOpen = Boolean(drawerBefore && drawerBefore.hasAttribute('open'));
    existing.replaceWith(next);

    if (wasOpen && sectionId === 'cart-drawer-section') {
      // Wait a tick for custom element upgrade
      requestAnimationFrame(function () {
        openCartDrawer();
      });
    }
    return true;
  }

  function fetchSectionHtml(sectionId) {
    var url = new URL(window.location.href);
    url.searchParams.set('section_id', sectionId);
    url.searchParams.set('_', String(Date.now()));
    return fetch(url.toString(), { headers: { Accept: 'text/html' } }).then(function (r) {
      if (!r.ok) throw new Error('Section fetch failed');
      return r.text();
    });
  }

  /**
   * Re-render cart drawer (and any cart-items sections) after cart mutations.
   */
  function reRenderCartSections(sectionsFromResponse) {
    var ids = getCartSectionIds();
    var tasks = ids.map(function (id) {
      if (sectionsFromResponse && sectionsFromResponse[id]) {
        applySectionHtml(id, sectionsFromResponse[id]);
        return Promise.resolve();
      }
      return fetchSectionHtml(id)
        .then(function (html) {
          applySectionHtml(id, html);
        })
        .catch(function (err) {
          console.warn('[onaks] section render failed', id, err);
        });
    });
    return Promise.all(tasks);
  }

  function cartAdd(items) {
    var sectionIds = getCartSectionIds();
    var payload = {
      items: items,
      sections: sectionIds.join(','),
      sections_url: window.location.pathname,
    };

    return fetch(cartRoot + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload),
    }).then(function (r) {
      if (!r.ok) throw new Error('Cart error');
      return r.json();
    });
  }

  function refreshCartDrawer(addResponse) {
    var sections = addResponse && addResponse.sections;
    return reRenderCartSections(sections)
      .then(function () {
        return fetch(cartRoot + 'cart.js', { headers: { Accept: 'application/json' } });
      })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        updateCartCount(cart.item_count || 0);
        openCartDrawer();
      })
      .catch(function () {
        updateCartCount();
        openCartDrawer();
      });
  }

  function initCartTrigger() {
    document.querySelectorAll('[data-ot-cart-trigger], [data-trigger-cart-drawer]').forEach(function (el) {
      if (el.dataset.otBound) return;
      el.dataset.otBound = '1';
      el.addEventListener('click', function (e) {
        // Always re-render drawer so it reflects current cart before open
        e.preventDefault();
        reRenderCartSections(null)
          .then(function () {
            if (!openCartDrawer()) {
              window.location.href = cartRoot + 'cart';
            }
          })
          .catch(function () {
            if (!openCartDrawer()) {
              window.location.href = cartRoot + 'cart';
            }
          });
      });
    });
  }

  function initQuickAdd() {
    document.querySelectorAll('[data-ot-add]').forEach(function (btn) {
      if (btn.dataset.otBound) return;
      btn.dataset.otBound = '1';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var id = btn.getAttribute('data-variant-id');
        if (!id) return;
        btn.disabled = true;
        var label = btn.textContent;
        btn.textContent = '…';
        cartAdd([{ id: Number(id), quantity: 1 }])
          .then(function (data) {
            btn.textContent = 'Added';
            return refreshCartDrawer(data).then(function () {
              setTimeout(function () {
                btn.textContent = label;
                btn.disabled = false;
              }, 1200);
            });
          })
          .catch(function () {
            btn.textContent = 'Error';
            setTimeout(function () {
              btn.textContent = label;
              btn.disabled = false;
            }, 1500);
          });
      });
    });
  }

  function initMultiAdd() {
    document.querySelectorAll('[data-ot-multi-add]').forEach(function (btn) {
      if (btn.dataset.otBound) return;
      btn.dataset.otBound = '1';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var raw = btn.getAttribute('data-ot-multi-add');
        if (!raw) return;
        var ids = raw
          .split(',')
          .map(function (s) {
            return s.trim();
          })
          .filter(Boolean);
        if (!ids.length) return;
        var items = ids.map(function (id) {
          return { id: Number(id), quantity: 1 };
        });
        btn.disabled = true;
        var label = btn.textContent;
        btn.textContent = 'Adding…';
        cartAdd(items)
          .then(function (data) {
            btn.textContent = 'Added';
            return refreshCartDrawer(data).then(function () {
              setTimeout(function () {
                btn.textContent = label;
                btn.disabled = false;
              }, 1400);
            });
          })
          .catch(function () {
            window.location.href = cartRoot + 'cart';
          });
      });
    });
  }

  /**
   * PDP form: intercept submit and use same AJAX + drawer refresh path.
   */
  function initProductForms() {
    document.querySelectorAll('form[data-ot-product-form], form[action*="/cart/add"]').forEach(function (form) {
      // Only Onak product forms (avoid double-binding Horizon forms)
      if (!form.closest('.ot-buy') && !form.hasAttribute('data-ot-product-form')) return;
      if (form.dataset.otBound) return;
      form.dataset.otBound = '1';
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var idInput = form.querySelector('[name="id"]');
        var qtyInput = form.querySelector('[name="quantity"]');
        var id = idInput && idInput.value;
        if (!id) return;
        var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
        var submitBtn = form.querySelector('[type="submit"][name="add"], button[type="submit"]');
        var label = submitBtn ? submitBtn.textContent : '';
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.textContent = 'Adding…';
        }
        cartAdd([{ id: Number(id), quantity: qty }])
          .then(function (data) {
            return refreshCartDrawer(data);
          })
          .then(function () {
            if (submitBtn) {
              submitBtn.textContent = 'Added';
              setTimeout(function () {
                submitBtn.textContent = label;
                submitBtn.disabled = false;
              }, 1200);
            }
          })
          .catch(function () {
            if (submitBtn) {
              submitBtn.disabled = false;
              submitBtn.textContent = label;
            }
            form.submit();
          });
      });
    });
  }

  function initVariantButtons() {
    document.querySelectorAll('[data-ot-variant-picker]').forEach(function (picker) {
      if (picker.dataset.otBound) return;
      picker.dataset.otBound = '1';
      var form = picker.closest('form');
      var idInput = form && form.querySelector('input[name="id"]');
      var priceEl = document.querySelector('[data-ot-price]');
      picker.querySelectorAll('[data-ot-variant]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          picker.querySelectorAll('[data-ot-variant]').forEach(function (x) {
            x.classList.remove('on');
          });
          btn.classList.add('on');
          if (idInput) idInput.value = btn.dataset.otVariant;
          if (priceEl && btn.dataset.price) priceEl.innerHTML = btn.dataset.price;
          document.querySelectorAll('[data-ot-atc-price]').forEach(function (el) {
            if (btn.dataset.priceLabel) el.textContent = btn.dataset.priceLabel;
          });
        });
      });
    });
  }

  function initSort() {
    var sel = document.querySelector('[data-ot-sort]');
    if (!sel || sel.dataset.otBound) return;
    sel.dataset.otBound = '1';
    sel.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sel.value);
      window.location.href = url.toString();
    });
  }

  function initCartPageQty() {
    document.querySelectorAll('[data-ot-cart-qty]').forEach(function (wrap) {
      if (wrap.dataset.otBound) return;
      wrap.dataset.otBound = '1';
      var key = wrap.getAttribute('data-line-key');
      var input = wrap.querySelector('input');
      var buttons = wrap.querySelectorAll('button');
      if (!input || !key) return;

      function setQty(q) {
        q = Math.max(0, q);
        input.value = q;
        var body = { id: key, quantity: q };
        fetch(cartRoot + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body),
        })
          .then(function (r) {
            return r.json();
          })
          .then(function () {
            window.location.reload();
          })
          .catch(function () {
            window.location.reload();
          });
      }

      if (buttons[0]) {
        buttons[0].addEventListener('click', function (e) {
          e.preventDefault();
          setQty((parseInt(input.value, 10) || 1) - 1);
        });
      }
      if (buttons[1]) {
        buttons[1].addEventListener('click', function (e) {
          e.preventDefault();
          setQty((parseInt(input.value, 10) || 1) + 1);
        });
      }
    });

    document.querySelectorAll('[data-ot-cart-remove]').forEach(function (btn) {
      if (btn.dataset.otBound) return;
      btn.dataset.otBound = '1';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var key = btn.getAttribute('data-line-key');
        if (!key) return;
        fetch(cartRoot + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: key, quantity: 0 }),
        }).then(function () {
          window.location.reload();
        });
      });
    });
  }

  function setHeaderHeights() {
    var group = document.querySelector('#header-group');
    if (!group) return;
    var h = group.offsetHeight || 0;
    document.body.style.setProperty('--header-height', h + 'px');
    document.body.style.setProperty('--header-group-height', h + 'px');
  }

  function boot() {
    document.body.classList.add('ot-theme');
    setHeaderHeights();
    window.addEventListener('resize', setHeaderHeights);
    initReveal();
    initAccordions();
    initGallery();
    initQty();
    initStickyAtc();
    initQuickAdd();
    initMultiAdd();
    initVariantButtons();
    initSort();
    initCartTrigger();
    initCartPageQty();
    initProductForms();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function () {
    initReveal();
    initAccordions();
    initGallery();
    initQty();
    initQuickAdd();
    initMultiAdd();
    initVariantButtons();
    initCartTrigger();
    initCartPageQty();
    initProductForms();
  });
})();
